import { Box, ContentLayout } from '@cloudscape-design/components';
import TableSchedules from 'src/components/schedule/TableSchedules';

const SchedulesPage = () => {
  return (
    <Box margin={{ top: 's' }}>
      <TableSchedules />
    </Box>
  );
};

export default SchedulesPage;
